import {Box, Divider, SimpleGrid, Stack, Table} from "@mantine/core";
import type {LocalLibraryEntry} from "@/app/storage";
import {LibraryCharacterTile} from "./LibraryCharacterTile";
import {LibraryEntryRow} from "./LibraryEntryRow";

export function LibraryGroupContent(props: {
  character: LocalLibraryEntry[];
  vocab: LocalLibraryEntry[];
  onEdit: (entry: LocalLibraryEntry) => void;
  onDelete: (uri: string) => void;
}) {
  const {vocab, character, onEdit, onDelete} = props;
  return (
    <Stack gap="md">
      {character.length > 0 && (
        <Box>
          <Divider label="Characters" labelPosition="left" mb="sm" />
          <SimpleGrid cols={{base: 3, sm: 4, md: 6}} spacing="sm">
            {character.map(entry => (
              <LibraryCharacterTile
                key={entry.uri}
                entry={entry}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </SimpleGrid>
        </Box>
      )}
      {vocab.length > 0 && (
        <Box>
          <Divider label="Vocabulary" labelPosition="left" mb="sm" />
          <Table highlightOnHover>
            <Table.Tbody>
              {vocab.map(entry => (
                <LibraryEntryRow
                  key={entry.uri}
                  entry={entry}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))}
            </Table.Tbody>
          </Table>
        </Box>
      )}
    </Stack>
  );
}
